import React, { Component } from "react";
import SocialSecurityForm from "../SocialSecurityForm/SocialSecurityForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SocialSecurityPage
Description : Componente que contienen el formulario de la pantalla SocialSecurity 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina - Se llama al componente SocialSecurityForm
================================================================================ */
class SocialSecurityPage extends Component{
    render(){
        return(
            <div>                    
                <SocialSecurityForm/>
            </div>
        )   
    }
}

export default SocialSecurityPage;